import { AccordionCustom } from 'components';
import { AccordionDataL3 } from './accordionDataL3';
import { L3Recap } from '../L3Recap';

// Sotto-tab di L3, mirror di contextAccordionTabsL0/L1
// (components/TabCreateInspection/costants.js) ma con solo 2 voci — tenuto
// nella cartella L3/ (non in costants.js) per evitare un import circolare:
// costants.js importa già L3Idraulica.jsx, che a sua volta consuma questo
// file.
export const contextAccordionTabsL3 = [
  {
    label: 'Contesto dati generali',
    content: <AccordionCustom checkExpanded accordions={AccordionDataL3} />,
    value: 0,
  },
  {
    label: 'Riepilogo',
    content: <L3Recap />,
    value: 1,
  },
];
